import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WholesaleLimit } from "./WholesaleLimit";
import { Box, Paper, Grid, Typography, makeStyles } from "@material-ui/core";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { ExportWholesaleLimitButton } from "./ExportWholesaleLimitButton";
import { useResource } from "@rest-hooks/core";
import { VulcanDataResource } from "@ploy-lib/rest-resources";
const useStyles = makeStyles((theme) => ({
    page: {
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(0)
        }
    },
    paper: {
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(1)
        }
    }
}));
const messages = defineMessages({
    exportWholesaleLimitButton: {
        id: "dealer.wholesalelimit.exportbutton",
        description: "Label for exportWholesalelimitButton",
        defaultMessage: "Eksporter oversikt"
    }
});
const WholesaleLimitPage = () => {
    const classes = useStyles();
    const intl = useIntl();
    const { vendorId } = useResource(VulcanDataResource.detail(), {});
    return (_jsx(Box, { p: 4, className: classes.page, children: _jsx(Box, { p: 4, component: Paper, className: classes.paper, children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, children: _jsx(Typography, { gutterBottom: true, variant: "h4", children: _jsx(FormattedMessage, { id: "dealer.wholesalelimit.header", description: "Header for wholesalelimit page", defaultMessage: "Wholesale limit" }) }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(WholesaleLimit, { vendorId: vendorId }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(ExportWholesaleLimitButton, { vendorId: vendorId, label: intl.formatMessage(messages.exportWholesaleLimitButton) }) })] }) }) }));
};
export { WholesaleLimitPage };
//# sourceMappingURL=WholesaleLimitPage.js.map